import PropTypes from 'prop-types'
import { LinkStyled } from './styled-components'
import { setHttp } from '@/shared/tools/httpFunctions'

const DistributorWebsite = ({ website, t }) => {
  if (website) {
    return (
      <LinkStyled href={setHttp(website)} target="_blank" rel="noopener noreferrer">
        {t('subscriptionForm:distributor.field_website')}
      </LinkStyled>
    )
  }
  return <>{t('subscriptionForm:distributor.no_website')}</>
}

DistributorWebsite.propTypes = {
  website: PropTypes.string,
  t: PropTypes.func.isRequired,
}

export default DistributorWebsite
